import React from 'react'
import './style.less'
import { Table, Tag, Space } from 'antd';

export default class ParametersContent extends React.Component{
    render() {
        const columns = [
            {
                title: '规格',
                dataIndex: 'Specification',
                key: 'Specification',
                align:"center"
            },
            {
                title: '参数',
                dataIndex: 'param',
                key: 'param',
                align:"center"
            },
        ];

        const data = [
            {
                key: '1',
                Specification: '工作频率',
                param: "1.4GHz/2.4GHz(或定制）",
            },
            {
                key: '2',
                Specification: '信号带宽',
                param: "20MHz",
            },
            {
                key: '3',
                Specification: '射频发射功率',
                param: "2W(50km)、4W(100km)",
            },
            {
                key: '4',
                Specification: '射频接收灵敏度',
                param: "-90dBm",
            },
            {
                key: '5',
                Specification: '有效传输距离',
                param: "30km/50km/100km/150km (LOS) ",
            },
            {
                key: '6',
                Specification: '调制方式',
                param: "QPSK",
            },
            {
                key: '7',
                Specification: '链接速率',
                param: "10Mbps",
            },
            {
                key: '8',
                Specification: 'HD 图像终端的最小延迟',
                param: "250ms",
            },
            {
                key: '9',
                Specification: '冷启动时间',
                param: "5s",
            },
            {
                key: '10',
                Specification: '链路建立时间',
                param: "10 ms",
            },
            {
                key: '11',
                Specification: '工作温度',
                param: "-35°C~+60°C",
            },
        ];
        return (
            <div className={'parameterContent'}>
                <Table columns={columns} dataSource={data} pagination={false}/>
            </div>
        )
    }
}
